
document.addEventListener('DOMContentLoaded', function() {
    function manageSizeCharts() {
        const allLinks = document.querySelectorAll('.variant-picker a');
        const sizeChartLinks = [];
        
        allLinks.forEach(link => {
            if (link.textContent.includes('Size Chart') || 
                link.textContent.includes('SIZE CHART') ||
                link.getAttribute('href') === '#') {
                sizeChartLinks.push(link);
            }
        });
        
        if (sizeChartLinks.length >= 2) {
            sizeChartLinks[0].style.display = 'block';
            sizeChartLinks[1].style.display = 'none';
        }
    }
    
    manageSizeCharts();
    setTimeout(manageSizeCharts, 100);
    setTimeout(manageSizeCharts, 500);
});
